<template>
  <div v-if="!loading" class="reservation-timer">
    <div class="countdown" v-if="!showMessage && nrOfReservations > 0">{{ formattedReservationMessage }}</div>
    <div class="alert-message" v-else-if="showMessage">
      <p>{{ formattedExpiredMessage }}</p>
    </div>
  </div>
</template>


<script>
import { ref, computed, watch } from 'vue';
import useReservationTimer from '@/composables/useReservationTimer';
import useSettings from "@/composables/useSettings";
import useTexts from "@/composables/useTexts";

export default {
  name: 'ReservationTimer',
  props: {
    showMessage: {
      type: Boolean,
      default: false,
    },
    nrOfReservations: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { remainingTime, fetchRemainingTime } = useReservationTimer();
    const {settings} = useSettings();
    const intervalId = ref(null);
    const loading = ref(true);
    const counterTimeout = 1000; //When developing, put it on 100 or 10 to speed up the timer, in production 1000
    const { getTextsForComponent, replacePlaceholders } = useTexts();
    const t = getTextsForComponent('ReservationTimer');

    const formattedReservationMessage = computed(() => {
      return replacePlaceholders(t.value.reservation_expired, { formatted_time: formattedTime(remainingTime.value, t.value) });
    });

    const formattedExpiredMessage = computed(() => {
      return replacePlaceholders(t.value.reservation_expired_message, { formatted_time: formattedTime(settings.value.reservation_timeout, t.value) });
    });

    const formattedTime = (secondsInput, t) => {
      const { minutes, seconds } = convertSecondsToTime(secondsInput);
      let formattedTime = `${minutes} ${minutes !== 1 ? t.minutes : t.minute}`;

      if (seconds > 0) {
        formattedTime += ` en ${seconds} ${seconds !== 1 ? t.seconds : t.second}`;
      }

      return formattedTime;
    };


    const startTimer = async () => {
      loading.value = true;
      await fetchRemainingTime();
      loading.value = false;

      intervalId.value = setInterval(() => {
        if (remainingTime.value > 0) {
          remainingTime.value -= 1;
        } else {
          clearInterval(intervalId.value);
          emit('timeExpired');
        }
      }, counterTimeout);
    };

    const stopTimer = () => {
      if (intervalId.value) {
        clearInterval(intervalId.value);
        intervalId.value = null;
      }
    };

    const convertSecondsToTime = (timeInSeconds) => {
      const minutes = Math.floor(timeInSeconds / 60);
      const seconds = timeInSeconds % 60;

      return { minutes, seconds };
    }

    watch(() => props.nrOfReservations, async (newValue, oldValue) => {
      if (newValue > 0 && oldValue <= 0) {
        await startTimer();
      } else if (newValue <= 0 && oldValue > 0) {
        stopTimer();
      }
    }, { immediate: true });

    return {
      settings,
      loading,
      formattedTime,
      replacePlaceholders,
      remainingTime,
      t,
      formattedReservationMessage,
      formattedExpiredMessage,
    };
  }
};
</script>
